import React, { useState } from 'react';
import axios from 'axios';

import ImageGrid from '../components/ImageGrid';
import { useLocation, useNavigate } from 'react-router-dom';
import { Container, TextField, Checkbox, FormControlLabel, Button, Typography, Box, styled} from '@mui/material';

import RefreshIcon from '@mui/icons-material/Refresh';
import Check from '@mui/icons-material/Check';
import TheatersIcon from '@mui/icons-material/Theaters';
import AdminProductView from '../components/AdminProductView';
import Grid from '@mui/material/Unstable_Grid2'; // Grid version 2

import CloseIcon from '@mui/icons-material/Close';

import Sidebar from '../components/Sidebar';
import ImageGalleryWithCarusel from '../components/ImageGalleryWithCarusel';
import config from '../config';
import FurnitureViewer from '../components/FurnitureViewer';


const PageContainer = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  alignContent: 'center',
  width: '100%',
  height: '100%',
});

const ButtonWrapper = styled('div')(({ theme }) => ({
  margin: theme.spacing(2),
  marginLeft: "0",
  marginBottom: theme.spacing(5),
  marginTop: 'auto',
  display: 'flex',
  justifyContent: 'center',
}));

const ContentContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  alignContent: 'center',
  width: '100%',
});

const ReviewPageHeader = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'start',
  alignItems: 'start',
  alignContent: 'start',
  width: '100%',
});

const DeleteRender  = () => {

  const navigate = useNavigate();
   const [productId, setProductId] = useState('');
  const [size, setSize] = useState('');
  const [deleteModel, setDeleteModel] = useState(false);
  const [status, setStatus] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {

      const params = {
        product_id: productId,
      };
      if (size) {
        params.size = parseInt(size);
      }
      params.delete_model = deleteModel;

      const response = await axios.delete(`${config.serverUrl}/render`, {
        params: params
      });

      setStatus(response.data.status);
    } catch (error) {
      setStatus('Error: ' + error.message);
    }
  };

  return (
  <PageContainer>
      <Sidebar navigate={navigate} />
      <ContentContainer>
        <Container maxWidth="sm">
             <Box sx={{ mt: 4 }}>
                <Typography variant="h4" component="h1" gutterBottom>
                  Delete Render
                </Typography>
                <form onSubmit={handleSubmit}>
                  <TextField
                    label="Product ID"
                    type="number"
                    value={productId}
                    onChange={(e) => setProductId(e.target.value)}
                    fullWidth
                    required
                    margin="normal"
                  />
                  <TextField
                    label="Size"
                    type="number"
                    value={size}
                    onChange={(e) => setSize(e.target.value)}
                    fullWidth
                    margin="normal"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={deleteModel}
                        onChange={(e) => setDeleteModel(e.target.checked)}
                      />
                    }
                    label="Delete Model"
                  />
                  <Box sx={{ mt: 2 }}>
                    <Button type="submit" variant="contained" color="primary" fullWidth>
                      Delete
                    </Button>
                  </Box>
                </form>
                {status && (
                  <Typography variant="body1" color="textSecondary" sx={{ mt: 2 }}>
                    {status}
                  </Typography>
                )}
              </Box>
            </Container>
      </ContentContainer>
    </PageContainer>
  );
};

export default DeleteRender;
